export default "__VITE_ASSET__2LM$00vi__"